import { useEffect } from "react";

interface Options {
  /** Extra attributes to set on the <script> tag (data-* attributes etc.) */
  attrs?: Record<string, string>;
  /** Where to append the tag. Defaults to <body>. */
  target?: "body" | "head";
}

/**
 * Loads a third-party script exactly once per page, no matter how many
 * components request it. Used for the LeadConnector form embed, the
 * reputation review widget and the chat bubble.
 */
export function useExternalScript(src: string, { attrs, target = "body" }: Options = {}) {
  useEffect(() => {
    if (!src) return;
    if (document.querySelector(`script[src="${src}"]`)) return;

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    if (attrs) {
      Object.entries(attrs).forEach(([key, value]) => script.setAttribute(key, value));
    }
    (target === "head" ? document.head : document.body).appendChild(script);
    // The script is intentionally left in place — third-party widgets
    // register global listeners and removing the tag does not unregister them.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);
}
